








import { Component, Vue } from "vue-property-decorator";
import { Company, Office } from "@/api/company-api";
import saveCompany from "@/helpers/saveCompany";

import CompanyEdit from "@/templates/CompanyEdit.vue";
import createCompany from "@/helpers/createCompany";

@Component({
  components: {
    CompanyEdit
  }
})
export default class CompanyNewPage extends Vue {
  company: Company | null = null;
  office: Office | null = null;
  async ok() {
    if (!this.company || !this.office) return;
    await saveCompany(this.company, this.office);
    this.goListPage();
  }

  cancel() {
    this.goListPage();
  }

  remove() {
    this.goListPage();
  }

  private created() {
    [this.company, this.office] = createCompany();
    this.office.profitRate = 0;
  }

  private goListPage() {
    this.$router.push({ name: "companies-list" });
  }
}
